<template>
  <div>
    <div class="product-window group-con" :class="attr.cartAttr === true ? 'on' : ''"
      :style="'padding-bottom:' + (isShowBtn ? '0' : '')">
      <div class="textpic acea-row row-between-wrapper">
        <div class="pictrue">
          <img :src="attr.productSelect.image" class="image" />
        </div>
        <div class="text">
          <div class="line1">
            {{ attr.productSelect.store_name }}
          </div>
          <div class="money font-color-red">
            ￥<span class="num">{{ attr.productSelect.price }}</span>
            <!-- <span class="stock" v-if="isShow">
				库存: {{ attr.productSelect.stock }}
			  </span>
			  <span class="stock" v-else>
				限量:
				{{
				  attr.productSelect.quota_show
					? attr.productSelect.quota_show
					: 0
				}}
			  </span> -->
            <span class="stock"> 库存: {{ attr.productSelect.stock }} </span>
          </div>
        </div>
        <div class="iconfont icon-guanbi" @click="closeAttr"></div>
      </div>
      <div class="rule-box">
        <!-- 普通 spec_type == 0 -->
        <div class="productWinList" v-if="attr.RuleData.spec_type == 0">
          <div class="item" v-for="(item, indexw) in attr.productAttr" :key="indexw">
            <div class="title">{{ item.attr_name }}</div>
            <div class="listn acea-row row-middle">
              <button class="itemn1" :class="item.index === itemn.attr ? 'on' : ''" :style="itemn.disabled === true
        ? 'color: #c8c9cc;background: #f2f3f5;'
        : ''
        " v-for="(itemn, indexn) in item.attr_value" @click="tapAttr(indexw, itemn)" :key="indexn"
                :disabled="itemn.disabled">
                {{ itemn.attr }}
              </button>
            </div>
          </div>
        </div>
        <!-- 多选 spec_type == 1 -->
        <div class="productWinList" v-if="attr.RuleData.spec_type == 1">
          <!-- 版本 indexw == 0 -->
          <div v-if="attr.productAttr[0].product_id != 245 && attr.productAttr[0].product_id != 345&& attr.productAttr[0].product_id != 349">
            <div class="item" v-for="(item, indexw) in attr.productAttr" :key="indexw">
              <div class="title">{{ item.attr_name }}</div>
              <div class="listn acea-row row-middle" v-if="indexw == 0">
                <button class="itemn1" :class="item.index === itemn.attr ? 'on itemn' : 'itemn'"
                  v-for="(itemn, indexn) in item.attr_value" @click="tapAttr(indexw, itemn)" :key="indexn">
                  {{ itemn.attr }}
                  <!-- {{ indexn == 0 ? '经典版' : indexn == 1 ? "听学盒子版" : '' }} -->
                </button>
              </div>

              <!-- 地区 indexw == 1 -->
              <div class="listn acea-row row-middle" v-if="indexw == 1">
                <button class="itemn" :class="item.index === itemn.attr ? 'on itemn' : 'itemn'" :style="itemn.disabled === true
        ? 'color: #c8c9cc;background: #f2f3f5;border-color: #f2f3f5;'
        : ''
        " v-for="(itemn, indexn) in item.attr_value" @click="tapAttr(indexw, itemn)" :key="indexn"
                  :disabled="itemn.disabled">
                  {{ itemn.attr }}
                </button>
              </div>
              <!-- 颜色 indexw == 2 -->
              <div class="listn acea-row row-middle" v-if="indexw == 2">
                <button class="itemn" :class="item.index === itemn.attr
        ? 'on itemn itemImg'
        : 'itemn itemImg'
        " style="justify-content: space-around;" :style="itemn.disabled === true
        ? 'color: #c8c9cc;background: #f2f3f5;border-color: #f2f3f5;'
        : ''
        " v-for="(itemn, indexn) in item.attr_value" @click="tapAttr(indexw, itemn)" :key="indexn"
                  :disabled="itemn.disabled">
                  {{
        indexn == 0
          ? "金榜红"
          : indexn == 1
            ? "金榜黑"
            : indexn == 2
              ? "无"
              : ""
      }}
                  <img src="../assets/images/heziHong.png" alt="" v-if="indexn == 0 && indexw == 2" />
                  <img src="../assets/images/heziHei.png" alt="" v-if="indexn == 1 && indexw == 2" />
                  <!-- <img
                  src="../assets/images/heziMoren.png"
                  alt=""
                  v-if="indexn == 2 && indexw == 2"
                /> -->
                </button>
              </div>
              <!-- 科目 indexw == 3 -->
              <div class="listn acea-row row-middle" v-if="indexw == 3">
                <div class="itemn checkbox" v-for="(checkbox, checkindex) in attr.RuleData.attr_values[
        attr.productAttr[1].index
      ]" :key="checkindex" @click="clickcheck(checkindex, checkbox)" :class="checkbox.check === true ? 'on' : ''">
                  {{ checkbox.attr }}
                </div>
              </div>
              <!-- 赠送 -->
              <div class="listn acea-row row-middle" v-if="indexw == 4">
                <button class="itemn1" :class="item.index === itemn.attr ? 'on itemn' : 'itemn'" :style="itemn.disabled === true
        ? 'color: #c8c9cc;background: #f2f3f5;border-color: #f2f3f5;'
        : ''
        " v-for="(itemn, indexn) in item.attr_value" @click="tapAttr(indexw, itemn)" :key="indexn"
                  :disabled="itemn.disabled">
                  {{ itemn.attr }}
                </button>
              </div>
              <!-- <div
              class="listn acea-row row-middle"
              v-if="indexw == 5"
            >
              <button
                class="itemn1"
                :class="item.index === itemn.attr ? 'on itemn' : 'itemn'"
                :style="
                  itemn.disabled === true
                    ? 'color: #c8c9cc;background: #f2f3f5;border-color: #f2f3f5;'
                    : ''
                "
                v-for="(itemn, indexn) in item.attr_value"
                @click="tapAttr(indexw, itemn)"
                :key="indexn"
                :disabled="itemn.disabled"
              >
                {{  indexn == 1
                    ? "不加购"
                    : itemn.attr}}
              </button>
            </div> -->
            </div>
          </div>
          <div v-else>
            <!-- 版本 -->
            <div class="item">
              <div class="title">{{ attr.productAttr[0].attr_name }}</div>
              <div class="listn acea-row row-middle">
                <button class="itemn1" :class="attr.productAttr[0].index === itemn.attr ? 'on itemn' : 'itemn'"
                  v-for="(itemn, indexn) in attr.productAttr[0].attr_value" @click="tapAttr(0, itemn)" :key="indexn">
                  {{ itemn.attr }}
                </button>
              </div>
            </div>
            <!-- 地区 -->
            <div class="item">
              <div class="title">{{ attr.productAttr[1].attr_name }}</div>
              <div class="listn acea-row row-middle">
                <button class="itemn" :class="attr.productAttr[1].index === itemn.attr ? 'on itemn' : 'itemn'" :style="itemn.disabled === true
        ? 'color: #c8c9cc;background: #f2f3f5;border-color: #f2f3f5;'
        : ''
        " v-for="(itemn, indexn) in attr.productAttr[1].attr_value" @click="tapAttr(1, itemn)" :key="indexn"
                  :disabled="itemn.disabled">
                  {{ itemn.attr }}
                </button>
              </div>
            </div>
            <!-- 科目 -->
            <div class="item">
              <div class="title">{{ attr.productAttr[3].attr_name }}</div>
              <div class="listn acea-row row-middle">
                <div class="itemn checkbox" v-for="(checkbox, checkindex) in attr.RuleData.attr_values[
        attr.productAttr[1].index
      ]" :key="checkindex" @click="clickcheck(checkindex, checkbox)" :class="checkbox.check === true ? 'on' : ''">
                  {{ checkbox.attr }}
                </div>
              </div>
            </div>
            <!-- 加购 -->

            <div class="item" v-if="attr.productAttr[2].attr_name != '加购'">
              <div class="title">{{ attr.productAttr[2].attr_name }}</div>
              <div class="listn acea-row row-middle">
                <button class="itemn" :class="attr.productAttr[2].index === itemn.attr ? 'on' : ''" :style="itemn.disabled === true
          ? 'color: #c8c9cc;background: #f2f3f5;'
          : ''
        " v-for="(itemn, indexn) in attr.productAttr[2].attr_value" @click="tapAttr(2, itemn)" :key="indexn"
                  :disabled="itemn.disabled">
                  {{ itemn.attr }}
                </button>
              </div>
            </div>
            <div class="item" v-if="attr.productAttr[2].attr_name == '加购'">
              <div class="title">选购图书<br>加300元，即可获取《一轮教案》、《总复习大纲》全套6科图书，共计12册。</div> 
              <div class="listn acea-row row-middle">
                <button class="itemn1" :class="attr.productAttr[2].index === itemn.attr ? 'on itemn' : 'itemn'" :style="itemn.disabled === true
        ? 'color: #c8c9cc;background: #f2f3f5;border-color: #f2f3f5;'
        : ''
        " v-for="(itemn, indexn) in attr.productAttr[2].attr_value" @click="tapAttr(2, itemn)" :key="indexn"
                  :disabled="itemn.disabled">
                  {{ itemn.attr }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="cart">
          <div class="title">数量</div>
          <div class="carnum acea-row row-left">
            <div class="item reduce" :class="attr.productSelect.cart_num <= 1 ? 'on' : ''" @click="CartNumDes">
              -
            </div>
            <div class="item num">
              <input type="number" v-model="attr.productSelect.cart_num" class="ipt_num" />
            </div>
            <div class="item plus" :class="attr.productSelect.cart_num >= attr.productSelect.stock
        ? 'on'
        : ''
        " @click="CartNumAdd">
              +
            </div>
            <div @click="define()" class="define" v-if="productid">确定</div>
          </div>
        </div>
      </div>
      <div class="wrapper" v-if="isShowBtn">
        <div class="teamBnt bg-color-red" @click="openAlone" v-if="attr.productSelect.quota > 0 && attr.productSelect.product_stock > 0
        ">
          立即参团
        </div>
        <div class="teamBnt bg-color-hui" v-else>已售罄</div>
      </div>
    </div>
    <div class="mask" @touchmove.prevent :hidden="attr.cartAttr === false" @click="closeAttr"></div>
  </div>
</template>

<script>
export default {
  name: "ProductWindow",
  props: {
    attr: {
      type: Object,
      default: () => { },
    },
    productid: Number, // 首页点击加入购物车商品id
  },
  data: function () {
    return {
      flag: false,
    };
  },
  computed: {
    isShow() {
      return this.$route.path.indexOf("detail") === 1;
    },
    isShowBtn() {
      return this.$route.path.indexOf("group_rule") != -1;
    },
  },
  mounted: function () {
    // this.getsubject();
  },
  methods: {
    //传给首页 点击确定加入购物车
    define() {
      var productid = this.productid;
      this.$emit("changeFun", { action: "define", value: productid });
    },
    openAlone() {
      this.$emit("changeFun", { action: "goPay", value: false });
    },
    closeAttr: function () {
      if (!this.productid) {
        document.getElementById("product-con").classList.remove("noscoll");
      } else {
        document.getElementById("index").classList.remove("noscoll");
      }
      this.$emit("changeFun", { action: "changeattr", value: false });
    },
    CartNumDes: function () {
      this.$emit("changeFun", { action: "ChangeCartNum", value: false });
    },
    CartNumAdd: function () {
      this.$emit("changeFun", { action: "ChangeCartNum", value: 1 });
    },
    tapAttr: function (indexw, itemn) {
      let that = this;
      let shopId = that.attr.productAttr[indexw].product_id
      console.log(that.attr.productAttr[indexw].product_id);
      // if (itemn.attr == "金榜入门版" || itemn.attr == "金榜入门版" && that.attr.productAttr[5].index == '《全考点普查一轮教案》6科') {
      //   that.attr.productAttr[4].index = "无赠送";
      //   that.attr.productAttr[2].index = "默认色";
      //   that.attr.productAttr[5].index ='无'
      // }
      // if (itemn.attr == "金榜入门版" || itemn.attr == "金榜入门版") {
      //   that.attr.productAttr[4].index = "无赠送";
      //   that.attr.productAttr[2].index = "默认色";
      // }
      // if (itemn.attr == "金榜题名版") {
      //   that.attr.productAttr[4].index = "《总复习大纲全套》";
      //   that.attr.productAttr[2].index = "金榜红";
      // }
      if (itemn.attr == '听学盒子版') {


        if (shopId == 245 || shopId == 345|| shopId == 349) {
          // that.attr.productAttr[2].index = '加购'
        } else {
          that.attr.productAttr[2].index = '金榜红'
        }
      }

      if (itemn.attr == '经典版') {
        that.attr.productAttr[2].index = '无'
      }
      // if (itemn.attr == 'app版') {
      //   that.attr.productAttr[2].index = '加购'
      //   // that.attr.productAttr[2].index = '无'
      // }
      that.$emit("changeFun", { action: "isCheckedValue", value: 2 });
      that.attr.productAttr[indexw].index = itemn.attr;
      let value = that.getCheckedValue().join(",");
      that.$emit("changeFun", { action: "ChangeAttr", value: value });
      that.$emit("changeFun", { action: "isCheckedValue", value: 1 });
      if (that.attr.RuleData.spec_type == 1) {
        that.getsubject();
      }
    },
    clickcheck: function (checkindex, checkbox) {
      let that = this;
      //现在的值
      let check = !checkbox.check;
      //已选数量
      let total_must =
        that.attr.RuleData.attr_value[that.attr.productAttr[1].index].must;
      //可选数量
      let total_sepc_num =
        that.attr.RuleData.attr_value[that.attr.productAttr[1].index].sepc_num;
      // that.attr.RuleData.attr_values[that.attr.productAttr[1].index][checkindex].check = !checkbox.check;
      if (!checkbox.must) {
        if (check) {
          if (total_must < total_sepc_num) {
            checkbox.check = check;
            that.attr.RuleData.attr_value[that.attr.productAttr[1].index]
              .must++;
            //console.log("加数量"+that.attr.RuleData.attr_value[that.attr.productAttr[1].index].must);
          } else {
            //失败
            that.$layer.msg(
              "选择科目不能大于" +
              that.attr.RuleData.attr_value[that.attr.productAttr[1].index]
                .sepc_num +
              "科"
            );
          }
        } else {
          checkbox.check = check;
          that.attr.RuleData.attr_value[that.attr.productAttr[1].index].must--;
          //console.log("减数量"+that.attr.RuleData.attr_value[that.attr.productAttr[1].index].must);
        }
      } else {
        that.$layer.msg("必选科目");
      }
      // console.log(that.attr.RuleData.attr_values[that.attr.productAttr[1].index]);
      that.getsubject();
    },
    //获取被选中科目
    getsubject: function () {
      let that = this;
      let RuleData =
        this.attr.RuleData.attr_values[that.attr.productAttr[1].index];
      let value = [];
      for (let i = 0; i < RuleData.length; i++) {
        if (RuleData[i].check) {
          value.push(RuleData[i].attr);
        }
      }
      that.$emit("changeFun", { action: "ChangeSubject", value: value });
    },
    //获取被选中属性；
    getCheckedValue: function () {
      let productAttr = this.attr.productAttr;
      let value = [];
      for (let i = 0; i < productAttr.length; i++) {
        for (let j = 0; j < productAttr[i].attr_value.length; j++) {
          if (productAttr[i].index === productAttr[i].attr_value[j].attr) {
            value.push(productAttr[i].attr_value[j].attr);
          }
        }
      }
      return value;
    },
  },
};
</script>

<style scoped>
.joinCart {
  width: 80%;
  height: 0.76rem;
  line-height: 0.76rem;
  text-align: center;
}

.ipt_num {
  width: 100%;
  display: block;
  line-height: 0.54rem;
  text-align: center;
}

.checkbox {
  float: left;
}

.define {
  width: 100%;
  height: 0.7rem;
  line-height: 0.7rem;
  text-align: center;
  margin: 0.2rem auto;
  /* background-color: #fc3a1d; */
  color: #fff;
  border-radius: 5px;
}

.disable {
  background-color: #ccc;
}

.product-window .productWinList {
  max-height: none;
}

.rule-box {
  overflow: auto;
  max-height: 8rem;
  padding-bottom: 0.5rem;
}

.itemn {
  width: 31%;
  min-height: 0.9rem;
  /* text-align: center; */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
}

.itemImg {
  display: flex;
  justify-content: space-between;
}

.itemn.on {
  background-color: "";
}

.itemn img {
  width: 0.5rem;
  height: 0.6rem;
  /* margin-left: 0.3rem; */
}

.itemn1 {
  width: 48%;
  min-height: 0.9rem;
  /* text-align: center; */
  display: flex;
  align-items: center;
  justify-content: center;
}

.product-window .productWinList .item .listn .itemn1 {
  border: 1px solid #bbb;
  font-size: 0.26rem;
  color: #999;
  padding: 0.07rem 0.15rem;
  border-radius: 0.06rem;
  margin: 0.14rem 0 0 0.14rem;
  min-height: 1.2rem;
}

.product-window .productWinList .item .listn .itemn1.on {
  color: #222222;
  /* background-color: #ff3700; */
  border-color: #3780ff;
}

.product-window .productWinList .item .listn .itemn {
  padding: 0.2rem;
}

.product-window .productWinList .item .listn .itemn.on {
  color: #222222;
  background-color: initial;
  border-color: #3780ff;
}

.product-window .productWinList .item .listn .itemn {
  color: #999;
}

@media screen and (min-width: 960px) {
  .joinCart {
    height: 0.38rem;
    line-height: 0.38rem;
  }

  .ipt_num {
    line-height: 0.27rem;
  }

  .define {
    height: 0.35rem;
    line-height: 0.35rem;
    margin: 0.1rem auto;
  }

  .rule-box {
    max-height: 4rem;
    padding-bottom: 0.25rem;
  }

  .product-window .productWinList .item .listn .itemn {
    padding: 0.2rem;
  }

  .product-window .productWinList .item .listn .itemn1 {
    font-size: .13rem;
    margin: 0.14rem 0 0 0.07rem;
    min-height: .6rem;
  }

  .itemn {
    min-height: .6rem;
  }

  .itemn img {
    width: 0.2rem;
    height: 0.2rem;
  }
}

@media screen and (min-width:768px) {
  .rule-box {
    max-height: 4rem;
    padding-bottom: 0.25rem;
  }
}
</style>